<template>
  <div class="business-model-box">
    <!-- 商业模式案例 -->
    <div class="the-body-box clearfix">
      <div class="f-l model-left-box">
        <div
          class="tab-item"
          v-for="(item, i) in tabsList"
          :key="i"
          :class="currTab == i ? 'active' : ''"
          @click="currTab = i"
        >
          <div>{{ $t(item.name) }}</div>
          <div class="line"></div>
        </div>
      </div>
      <div
        class="f-r model-right-box"
        :class="currTab > 0 ? `tab${currTab}` : ''"
      >
        <div class="">
          <img :src="$t(tabsList[currTab].content)" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-7CH9447NP2"></script>
<script>
export default {
  data() {
    return {
      tabsList: [
        {
          name: "BusinessModel.Amateur",
          content: "BusinessModel.AmateurUrl",
          // content: require("../../../../assets/img/enthusiast.jpg"),
        },
        {
          name: "BusinessModel.Artists",
          content: "BusinessModel.ArtistsUrl",
          // content: require("../../../../assets/img/artist.jpg"),
        },
        {
          name: "BusinessModel.ArtSpecialist",
          content: "BusinessModel.ArtSpecialistUrl",
          // content: require("../../../../assets/img/art_expert.jpg"),
        },
        {
          name: "BusinessModel.PrivateArtSteward",
          content: "BusinessModel.PrivateArtStewardUrl",
          // content: require("../../../../assets/img/private_art_butler.jpg"),
        },
        {
          name: "BusinessModel.ArtPromotionManager",
          content: "BusinessModel.ArtPromotionManagerUrl",
          // content: require("../../../../assets/img/art_promotion_manager.jpg"),
        },
      ],
      currTab: 0,
    };
  },
  created() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());

    gtag("config", "G-7CH9447NP2");
  },
};
</script>
<style lang="scss" scoped>
.business-model-box {
  padding: 64PX 0;
  border-top: 2PX solid #e6e6e6;
  .model-left-box {
    width: 150PX;
    padding-top: 60PX;
    .tab-item {
      margin-bottom: 47PX;
      font-size: 18PX;
      color: #666;
      font-weight: bold;
      cursor: pointer;
      .line {
        width: 30PX;
        height: 3PX;
        margin-top: 9PX;
        background-color: transparent;
      }
      &.active {
        color: #333;
        .line {
          background-color: $main-color;
        }
      }
    }
  }
  .model-right-box {
    position: relative;
    width: 1040PX;
    padding: 20PX;
    box-shadow: 0 0 15PX 5PX #eee;
    &::after {
      position: absolute;
      display: inline-block;
      zoom: 1;
      top: 56PX;
      left: -13PX;
      width: 0;
      height: 0PX;
      content: "";
      border-style: solid;
      border-width: 30PX 30PX 0 0;
      border-color: transparent #fff #fff transparent;
      transform: rotate(135deg);
      box-shadow: 4PX 4PX 5PX #f5f5f5;
    }
    &.tab1 {
      &::after {
        top: 135PX;
      }
    }
    &.tab2 {
      &::after {
        top: 210PX;
      }
    }
    &.tab3 {
      &::after {
        top: 288PX;
      }
    }
    &.tab4 {
      &::after {
        top: 364PX;
      }
    }
  }
}
</style>